import {ActionList} from '@primer/react'
import {useLayoutRouteData} from '../../page-data/loaders/use-layout-route-data'
import {useOverviewRouteData} from './data/use-overview-route-data'
import {PullRequestState} from '../../types'
import {isPullRequestOpenState} from '../../utils/pull-request-state'
import {CloseAction} from './sidebar-actions/CloseAction'
import {ConvertToDraftAction} from './sidebar-actions/ConvertToDraftAction'
import {MarkReadyForReviewAction} from './sidebar-actions/MarkReadyForReviewAction'
import {ReopenAction} from './sidebar-actions/ReopenAction'
import styles from './SidebarActions.module.css'
import sidebarListStyles from './SidebarActionList.module.css'
import {clsx} from 'clsx'

export function SidebarActions() {
  const {pullRequest} = useLayoutRouteData()
  const {user} = useOverviewRouteData()

  const showMarkReadyForReview = pullRequest.state === PullRequestState.Draft && user?.canMarkReadyForReview
  const showConvertToDraft = pullRequest.state === PullRequestState.Open && user?.canConvertToDraft
  const showClose = isPullRequestOpenState(pullRequest.state) && user?.canClose
  const showReopen = pullRequest.state === PullRequestState.Closed && user?.canReopen

  if (!showMarkReadyForReview && !showConvertToDraft && !showClose && !showReopen) {
    return null
  }

  return (
    <ActionList
      variant="full"
      aria-label="Pull request actions"
      className={clsx(styles.SidebarActions, sidebarListStyles.flush, sidebarListStyles.compact)}
    >
      {showMarkReadyForReview && <MarkReadyForReviewAction />}
      {showConvertToDraft && <ConvertToDraftAction />}
      {showClose && <CloseAction />}
      {showReopen && <ReopenAction />}
      {/* TODO: Lock conversation */}
    </ActionList>
  )
}
